import { Record } from 'immutable';
import { cleanString } from '../utilities';
import MemberExtendedRecord from './MemberExtended';

export default class OfficeRecord extends Record({
  id: undefined,
  company: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  zip: '',
  phone: '',
  phone2: '',
  fax: '',
  type: '',
  licenseNumber: '',
  brokerAccountNumber: '',
  mlsYN: '',
  active: '',
  joinDate: null,
  termDate: null,
  changeDate: null,
  website: '',
  emailAddress: '',
  primarySpecialty: '',
  extended: new MemberExtendedRecord(),
  numAgents: null,
  photo: ''
  // OLD
  // id: undefined,
  // headOfficeMui: null,
  // headOfficeMlsId: null,
  // matrixUniqueId: null,
  // email: '',
  // phone: '',
  // faxPhone: '',
  // webPageAddress: null,
  // matrixModifiedDT: null,
  // membershipDate: null,
  // mls: null,
  // mlsId: null,
  // officeContact_MUI: null,
  // officeContactMLSID: null,
  // officeLongName: '',
  // officeName: '',
  // officeStatus: 'Active',
  // officeType: null,
  // mailAddress: '',
  // mailCareOf: null,
  // mailCity: '',
  // mailPostalCode: '',
  // mailPostalCodePlus4: '',
  // mailStateOrProvince: '',
  // streetAddress: null,
  // streetCity: null,
  // streetCountry: null,
  // streetPostalCode: null,
  // streetPostalCodePlus4: null,
  // streetStateOrProvince: null,
  // extended: new MemberExtendedRecord(),
  // numAgents: null
}) {
  constructor(data = {}) {
    data.website = cleanString(data.website);

    if (data.extended) {
      data.extended = new MemberExtendedRecord(data.extended);
    }

    super(data);
  }
}



// WEBPACK FOOTER //
// ./src/records/Office.js